// --- Dependencies -------------------------------------------------------------------------------
import { InputAdornment, TextField } from "@mui/material";
// --- Our Modules --------------------------------------------------------------------------------
import "../field.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    value: number | null;
    onChange: (value: number | null) => void;
    label?: string;
    placeholder?: string;
    suffix?: string;
    min?: number;
    disabled?: boolean;
    /** The bar's variant — shorter and fixed-width, to sit level with the buttons beside it. */
    compact?: boolean;
};

/**
 * A number that may be **unknown**. Empty gives back `null`, not `0` — on a unit those are different
 * answers, and `0` pools on a villa is a fact somebody chose to record.
 *
 * Same floating label as `TextInput`, for the same reason: a column of numbers with their captions
 * scrolled off the top is a column of numbers nobody can read.
 */
export default function NumberInput({ value, onChange, label, placeholder, suffix, min = 0, disabled, compact }: Props) {
    return (
        <TextField
            className={`field${compact ? " field--compact" : ""}`}
            value={value ?? ""}
            onChange={(event) => {
                const next = event.target.value;
                onChange(next === "" ? null : Number(next));
            }}
            label={label}
            placeholder={label ? undefined : placeholder}
            type="number"
            disabled={disabled}
            slotProps={{
                htmlInput: { min, dir: "ltr" },
                input: suffix ? { endAdornment: <InputAdornment position="end">{suffix}</InputAdornment> } : undefined,
            }}
            variant="outlined"
            fullWidth={!compact}
        />
    );
}
